module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "mobileNot"
  }, [_c('div', {
    class: [_vm.builderMode === 'module' ? 'flexContainer jc-fe' : _vm.lock === 'true' ? 'flexContainer' : ''],
    attrs: {
      "id": "headerPlano"
    }
  }, [(_vm.builderMode !== 'module') ? _c('button', {
    staticClass: "btnLeft uppercase export pointer",
    on: {
      "click": _vm.exportPdf
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.export")))])]) : _vm._e(), _vm._v(" "), (_vm.lock === 'true' || _vm.access === 'false') ? _c('div', {
    staticClass: "flexContainer lock full"
  }, [_c('h2', {
    staticClass: "uppercase lockText center"
  }, [_c('img', {
    staticClass: "lockScreenLogo",
    attrs: {
      "src": require("../../../static/img/lockScreen.svg"),
      "alt": ""
    }
  }), _vm._v(" " + _vm._s(_vm.$t("plano.lock")) + "\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.builderMode !== 'module' && _vm.lock === 'false' && _vm.access === 'true') ? _c('button', {
    staticClass: "btnLeft uppercase support pointer",
    class: {
      active: _vm.support
    }
  }, [_c('span', [_c('a', {
    staticClass: "supportLink",
    attrs: {
      "target": "_blank",
      "href": _vm.globals + '/Plano-Builder-Guide-utilisateur.pdf'
    }
  }, [_vm._v(_vm._s(_vm.$t("planobuilder.support")))])])]) : _vm._e(), _vm._v(" "), (_vm.builderMode !== 'module' && _vm.lock === 'false' && _vm.access === 'true') ? _c('button', {
    staticClass: "btnLeft uppercase comment pointer",
    class: {
      active: _vm.comment
    },
    on: {
      "click": _vm.comments
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.comment")) + " (" + _vm._s(_vm.commentsNB) + ")")])]) : _vm._e(), _vm._v(" "), (_vm.builderMode !== 'module' && _vm.lock === 'false' && _vm.access === 'true') ? _c('button', {
    staticClass: "btnBase uppercase favorites fright pointer",
    class: {
      active: _vm.favorite
    },
    on: {
      "click": _vm.favorites
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.favorite")))])]) : _vm._e(), _vm._v(" "), (_vm.builderMode !== 'module' && _vm.lock === 'false' && _vm.access === 'true') ? _c('button', {
    staticClass: "btnBase uppercase scratch fright pointer",
    class: {
      active: _vm.scratch
    },
    on: {
      "click": _vm.scratchPad
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.scratch")))])]) : _vm._e(), _vm._v(" "), (_vm.builderMode !== 'module' && _vm.lock === 'false' && _vm.access === 'true') ? _c('button', {
    staticClass: "btnBase uppercase library fright pointer",
    class: {
      active: _vm.menuHeader
    },
    on: {
      "click": _vm.library
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.library")))])]) : _vm._e(), _vm._v(" "), (_vm.builderMode === 'module' && _vm.lock === 'false' && _vm.access === 'true') ? _c('button', {
    staticClass: "btnBase uppercase shades pointer",
    class: {
      active: _vm.menuShades
    },
    on: {
      "click": _vm.shades
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("planobuilder.shades")))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4601aee1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/HeaderPlano.vue
// module id = 3154
// module chunks = 0